(function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Catálogo real: productos publicados en la tienda online con inventario.
       Se filtran por las etiquetas de edad que ya usa el equipo y por precio.
       Forma de cada producto: t título, v marca, p precio, h handle, imgs fotos, d descripción,
       vars [ID de variante, nombre, disponible, precio], tags etiquetas normalizadas */
    var AGE_TAGS = {
        '0-12m': ['Bebes y todlers (0-2)', 'Bebés', '0 - 6 meses', '7 - 12 meses'],
        '1-3a': ['Bebes y todlers (0-2)', 'Primera infancia (2-6)', '13 - 18 meses', '13 -18 meses', '19 - 24 meses', '25 - 36 meses'],
        '3-6a': ['Primera infancia (2-6)'],
        '6-12a': ['Niños y niñas (6-12)']
    };
    var AGE_GROUP_TAGS = ['Bebes y todlers (0-2)', 'Primera infancia (2-6)', 'Niños y niñas (6-12)', 'Teens (12-18)', 'Adultos y familiares'];

    /* Género: las etiquetas aún no existen; cuando el equipo las agregue, la máquina ya las usa. */
    var GENDER_TAGS = { ella: 'Para niña', el: 'Para niño' };

    /* El tótem pasa el día encendido: el catálogo se vuelve a pedir si tiene más de 30 minutos */
    var CATALOG_TTL = 30 * 60 * 1000;
    var catalogPromise = null;
    var catalogAt = 0;

    function norm(s) {
        return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim();
    }

    function esc(s) {
        return String(s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }

    function imgUrl(src, w) {
        if (!src) return '';
        return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
    }

    function plainText(html, max) {
        var div = document.createElement('div');
        div.innerHTML = html || '';
        var text = (div.textContent || '').replace(/\s+/g, ' ').trim();
        return text.length > max ? text.slice(0, max).replace(/\s+\S*$/, '') + '…' : text;
    }

    function loadCatalog() {
        var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var products = [];
        function page(n) {
            return fetch(base + 'products.json?limit=250&page=' + n)
                .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
                .then(function (data) {
                    var list = data.products || [];
                    products = products.concat(list);
                    return list.length === 250 && n < 20 ? page(n + 1) : products;
                });
        }
        return page(1).then(function (list) {
            return list.map(function (p) {
                var vars = (p.variants || []).map(function (v) {
                    return [v.id, v.title === 'Default Title' ? '' : v.title, v.available, parseFloat(v.price)];
                });
                var available = vars.filter(function (v) { return v[2]; });
                if (!available.length) return null;
                return {
                    t: p.title,
                    v: p.vendor,
                    p: Math.min.apply(null, available.map(function (v) { return v[3]; })),
                    h: p.handle,
                    imgs: (p.images || []).map(function (im) { return im.src; }),
                    d: plainText(p.body_html, 260),
                    vars: vars,
                    tags: (p.tags || []).map(norm)
                };
            }).filter(Boolean);
        });
    }

    function getCatalog() {
        if (!catalogPromise || Date.now() - catalogAt > CATALOG_TTL) {
            catalogAt = Date.now();
            catalogPromise = loadCatalog();
            catalogPromise.catch(function () { catalogPromise = null; });
        }
        return catalogPromise;
    }

    function hasAny(product, tags) {
        return tags.some(function (t) { return product.tags.indexOf(norm(t)) !== -1; });
    }

    /* Un juguete marcado solo para esta edad va antes que uno marcado para todas las edades */
    function ageSpread(product) {
        return AGE_GROUP_TAGS.filter(function (t) { return product.tags.indexOf(norm(t)) !== -1; }).length;
    }

    var BUDGETS = { '300-500': [300, 500], '500-900': [500, 900], '900+': [900, Infinity] };
    var KEYS = ['age', 'gender', 'budget', 'occasion'];
    var SHAPES = ['circle', 'square', 'triangle', 'rect'];
    var LABELS = { age: 'Edad', gender: 'Para quién', budget: 'Presupuesto', occasion: 'Ocasión' };

    var STORE = 'https://didactijuegos.com';

    /* ---------- Ajustes del tótem ---------- */
    var IDLE_MS = 120000;      /* 2 minutos sin tocar la pantalla */
    var IDLE_COUNT = 15;
    var RELOAD_AFTER = 6 * 60 * 60 * 1000;   /* recarga la página cada 6 horas, siempre en la pantalla de espera */
    var BOOTED_AT = Date.now();       /* segundos del aviso "¿Sigues ahí?" antes de reiniciar */

    /* Destino del QR: PROVISIONAL hasta que el equipo lo decida.
       'carrito'  = carrito de didactijuegos.com con los 3 regalos (funciona hoy)
       'whatsapp' = abre WhatsApp en el celular con la lista
       'pagina'   = página de lista (pendiente de crear en Shopify) */
    var QR_MODE = 'carrito';
    var QR_UTM = 'utm_source=totem&utm_medium=qr&utm_campaign=maquina';

    /* Klaviyo: lista PENDIENTE de crear; mientras diga PENDIENTE, la maqueta simula el registro.
       En el tótem NO se identifica al navegador con el cliente (lo usan muchas personas). */
    var KLAVIYO = { company: 'VKtJJH', list: 'PENDIENTE' };

    var state = {};
    var labels = {};
    var current = 0;
    var resultsOffset = 0;
    var pool = [];
    var shown = [];
    var detailIdx = 0;
    var detailVar = null;

    /* Medición: solo conteo con origen "totem". Sin píxel de Meta ni Klaviyo onsite,
       porque todos los clientes comparten el mismo equipo y ensuciarían las audiencias. */
    function track(name, data) {
        data = Object.assign({ origen: 'totem' }, data || {});
        try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('gift_machine_' + name, data); } catch (e) {}
        try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'gift_machine_' + name }, data)); } catch (e) {}
    }

    var stage = document.getElementById('stage');
    var tickets = document.getElementById('tickets');
    var screens = Array.prototype.slice.call(document.querySelectorAll('.screen'));
    var stepItems = Array.prototype.slice.call(document.querySelectorAll('#stepper li'));
    var backBtn = document.getElementById('backBtn');

    function screenByName(name) {
        return screens.filter(function (s) { return s.dataset.screen === String(name); })[0];
    }

    function answered() {
        return KEYS.filter(function (k) { return state[k]; }).length;
    }

    function updateStage() {
        stage.style.setProperty('--drop', (answered() / KEYS.length).toFixed(2));
    }

    /* Cables entre el escenario y el panel */
    var grid = document.getElementById('machine');
    var panel = document.querySelector('.panel');
    var cables = document.getElementById('cables');
    var pulses = [];

    function drawCables() {
        var g = grid.getBoundingClientRect(), s = stage.getBoundingClientRect(), p = panel.getBoundingClientRect();
        if (!g.width) return;
        cables.setAttribute('viewBox', '0 0 ' + g.width + ' ' + g.height);
        var html = '';
        [0, 1].forEach(function (i) {
            var x1 = p.left - g.left + 10, y1 = p.top - g.top + p.height * (i ? 0.58 : 0.2);
            var x2 = s.right - g.left - 10, y2 = s.top - g.top + s.height * (i ? 0.64 : 0.26);
            var dx = (x1 - x2) * 0.55, sag = 34 + i * 10;
            var d = 'M' + x1 + ' ' + y1 + ' C' + (x1 - dx) + ' ' + (y1 + sag) + ' ' + (x2 + dx) + ' ' + (y2 + sag) + ' ' + x2 + ' ' + y2;
            html += '<path class="cable-base" d="' + d + '"/><path class="cable-rib" d="' + d + '"/><path class="cable-hi" d="' + d + '"/><path class="cable-pulse" d="' + d + '"/>' +
                '<circle class="plug" cx="' + x1 + '" cy="' + y1 + '" r="12"/><circle class="plug-core" cx="' + x1 + '" cy="' + y1 + '" r="5"/>' +
                '<circle class="plug" cx="' + x2 + '" cy="' + y2 + '" r="12"/><circle class="plug-core" cx="' + x2 + '" cy="' + y2 + '" r="5"/>';
        });
        cables.innerHTML = html;
        pulses = Array.prototype.slice.call(cables.querySelectorAll('.cable-pulse'));
    }

    function pulse() {
        if (reduceMotion) return;
        pulses.forEach(function (path, i) {
            var len = path.getTotalLength();
            path.style.strokeDasharray = '46 ' + len;
            path.style.opacity = 1;
            path.animate([{ strokeDashoffset: 46 }, { strokeDashoffset: -len }], { duration: 620, delay: i * 60, easing: 'cubic-bezier(0.4, 0, 0.6, 1)' })
                .onfinish = function () { path.style.opacity = 0; };
        });
    }

    drawCables();
    window.addEventListener('resize', drawCables);
    if ('ResizeObserver' in window) new ResizeObserver(drawCables).observe(panel);

    function renderTickets() {
        tickets.innerHTML = '';
        KEYS.forEach(function (key, i) {
            if (!state[key]) return;
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'ticket';
            b.setAttribute('aria-label', 'Cambiar ' + LABELS[key].toLowerCase() + ': ' + labels[key]);
            b.innerHTML = '<i class="shape shape-' + SHAPES[i] + '" aria-hidden="true"></i><small>' + LABELS[key] + '</small>' + labels[key];
            b.addEventListener('click', function () { show(i, true); });
            tickets.appendChild(b);
        });
    }

    function updateStepper() {
        stepItems.forEach(function (li, i) {
            li.classList.toggle('is-current', typeof current === 'number' && i === current);
            li.classList.toggle('is-done', Boolean(state[KEYS[i]]) && i !== current);
        });
        backBtn.disabled = current === 0 || current === 'loading';
    }

    function show(target, back) {
        var prev = screenByName(current);
        var next = screenByName(target);
        if (prev) prev.classList.remove('is-active', 'from-back');
        next.classList.toggle('from-back', Boolean(back));
        next.classList.add('is-active');
        current = target;
        updateStepper();
        stage.classList.toggle('is-done', target === 'results' || target === 'detail');
        if (target !== 'results') closeGate();
        panel.classList.toggle('is-results', target === 'results');
        panel.classList.toggle('is-detail', target === 'detail');
        stage.classList.toggle('is-searching', target === 'loading');
        if (target === 'results') stage.style.setProperty('--drop', '1.12');
        else if (target !== 'loading') updateStage();
    }

    /* Opciones */
    document.querySelectorAll('.opt').forEach(function (opt) {
        opt.addEventListener('click', function () {
            var key = opt.dataset.key;
            var group = opt.closest('.options');
            group.querySelectorAll('.opt').forEach(function (o) { o.classList.remove('is-selected'); });
            opt.classList.add('is-selected');
            if (!answered()) track('start', { step: key });
            state[key] = opt.dataset.value;
            labels[key] = opt.dataset.label;
            pulse();
            setTimeout(renderTickets, reduceMotion ? 0 : 520);
            updateStage();

            var idx = KEYS.indexOf(key);
            var pending = KEYS.findIndex(function (k) { return !state[k]; });
            setTimeout(function () {
                if (pending === -1) search();
                else show(pending > idx ? idx + 1 : pending);
            }, reduceMotion ? 0 : 380);
        });
    });

    document.querySelectorAll('.step-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
            var i = parseInt(btn.dataset.step, 10);
            if (state[KEYS[i]] && current !== 'loading') show(i, true);
        });
    });

    backBtn.addEventListener('click', function () {
        if (current === 'detail') show('results', true);
        else if (current === 'results') show(3, true);
        else if (typeof current === 'number' && current > 0) show(current - 1, true);
    });

    /* Búsqueda */
    function buildPool(catalog) {
        var range = BUDGETS[state.budget];
        var byAge = catalog.filter(function (p) { return hasAny(p, AGE_TAGS[state.age]); });

        var wanted = GENDER_TAGS[state.gender];
        if (wanted) {
            var other = state.gender === 'ella' ? GENDER_TAGS.el : GENDER_TAGS.ella;
            byAge = byAge.filter(function (p) { return !hasAny(p, [other]) || hasAny(p, [wanted]); });
        }

        function rank(a, b) {
            var ia = a.imgs.length ? 0 : 1, ib = b.imgs.length ? 0 : 1;
            var ga = wanted && hasAny(a, [wanted]) ? 0 : 1, gb = wanted && hasAny(b, [wanted]) ? 0 : 1;
            return (ia - ib) || (ga - gb) || (ageSpread(a) - ageSpread(b));
        }

        var inBudget = byAge.filter(function (p) { return p.p >= range[0] && p.p <= range[1]; }).sort(rank);
        var edge = range[1] === Infinity ? range[0] : range[1];
        var rest = byAge.filter(function (p) { return inBudget.indexOf(p) === -1; })
            .sort(function (a, b) {
                if (!a.imgs.length !== !b.imgs.length) return a.imgs.length ? -1 : 1;
                var da = Math.min(Math.abs(a.p - range[0]), Math.abs(a.p - edge));
                var db = Math.min(Math.abs(b.p - range[0]), Math.abs(b.p - edge));
                return da - db;
            });
        return inBudget.concat(rest);
    }

    var searchTimer = null;

    var searchRun = 0;

    function search() {
        show('loading');
        var run = ++searchRun;
        var catalog = getCatalog();
        var msgs = ['Revisando la edad…', 'Ajustando el presupuesto…', 'Eligiendo los mejores…'];
        var msg = document.getElementById('loadingMsg');
        var i = 0;
        msg.textContent = msgs[0];
        clearInterval(searchTimer);
        var animation = new Promise(function (resolve) {
            searchTimer = setInterval(function () {
                i++;
                if (i < msgs.length) {
                    msg.style.opacity = 0;
                    setTimeout(function () { msg.textContent = msgs[i]; msg.style.opacity = 1; }, 250);
                } else {
                    clearInterval(searchTimer);
                    resolve();
                }
            }, reduceMotion ? 10 : 750);
        });

        Promise.all([catalog, animation]).then(function (res) {
            pool = buildPool(res[0]);
        }).catch(function (err) {
            console.error('Máquina de regalos tótem: no se pudo cargar el catálogo', err);
            pool = [];
        }).then(function () {
            /* Si reiniciaron mientras buscaba, no se muestran resultados viejos */
            if (run !== searchRun || current !== 'loading') return;
            resultsOffset = 0;
            renderResults();
            show('results');
            track('complete', { age: state.age, gender: state.gender, budget: state.budget, occasion: state.occasion, results: pool.length });
        });
    }

    function money(n) {
        return '<sup>$</sup>' + n.toLocaleString('es-MX');
    }

    function renderResults() {
        var list = document.getElementById('results');
        var title = document.getElementById('resTitle');
        var sub = document.getElementById('resSub');
        var more = document.getElementById('moreBtn');
        list.innerHTML = '';

        if (!pool.length) {
            title.innerHTML = 'No encontramos regalos <span>con esta combinación</span>';
            sub.textContent = 'Prueba con otro presupuesto u otra edad, o pregunta a un asesor.';
            more.hidden = true;
            shown = [];
            paintQr();
            paintOffer();
            return;
        }

        var items = [];
        for (var i = 0; i < 3 && i < pool.length; i++) items.push(pool[(resultsOffset + i) % pool.length]);

        title.innerHTML = items.length + ' regalo' + (items.length > 1 ? 's' : '') + ' para <span>' + labels.age + '</span>';
        sub.textContent = labels.gender + ' · ' + labels.budget + ' · ' + labels.occasion;
        more.hidden = pool.length <= 3;

        shown = items;
        paintQr();
        paintOffer();
        items.forEach(function (p, i) {
            var li = document.createElement('li');
            li.className = 'r-card';
            li.style.setProperty('--d', (i * 0.08) + 's');
            li.innerHTML =
                '<span class="r-img" aria-hidden="true"><img src="' + imgUrl(p.imgs[0], 400) + '\" alt="" /></span>' +
                '<div><div class="r-vendor">' + esc(p.v) + '</div><h3 class="r-title">' + esc(p.t) + '</h3><div class="r-price">' + money(p.p) + '</div></div>' +
                '<button class="btn btn-dark btn-sm" type="button" aria-label="Ver ' + esc(p.t) + '"><span class="btn-txt">Ver regalo</span> <span class="arr" aria-hidden="true">→</span></button>';
            li.addEventListener('click', function () { openDetail(i); });
            list.appendChild(li);
        });
    }

    /* ---------- QR para llevarse la lista ---------- */
    function firstVariant(p) {
        return p.vars.filter(function (v) { return v[2]; })[0] || p.vars[0];
    }

    function shareText() {
        var lines = ['Mis regalos de la Máquina de Regalos de Didactijuegos:', ''];
        shown.forEach(function (p, i) {
            lines.push((i + 1) + '. ' + p.t + ' ($' + p.p.toLocaleString('es-MX') + ')');
            lines.push(STORE + '/products/' + p.h + '?' + QR_UTM);
            lines.push('');
        });
        return lines.join('\n');
    }

    function qrUrl() {
        if (QR_MODE === 'whatsapp') return 'https://wa.me/?text=' + encodeURIComponent(shareText());
        if (QR_MODE === 'pagina') return STORE + '/pages/mi-lista-de-regalos?regalos=' + shown.map(function (p) { return p.h; }).join(',') + '&' + QR_UTM;
        return STORE + '/cart/' + shown.map(function (p) { return firstVariant(p)[0] + ':1'; }).join(',') + '?' + QR_UTM;
    }

    function qrSvg(text) {
        var q = window.qrcode(0, 'M');
        q.addData(text);
        q.make();
        var n = q.getModuleCount(), m = 2, size = n + m * 2, d = '';
        for (var r = 0; r < n; r++) {
            for (var c = 0; c < n; c++) {
                if (q.isDark(r, c)) d += 'M' + (c + m) + ' ' + (r + m) + 'h1v1h-1z';
            }
        }
        return '<svg viewBox="0 0 ' + size + ' ' + size + '" shape-rendering="crispEdges"><rect width="' + size + '" height="' + size + '" fill="#FFF"/><path d="' + d + '" fill="#111827"/></svg>';
    }

    function paintQr() {
        var box = document.getElementById('qrBox');
        var ok = shown.length && typeof window.qrcode === 'function';
        stage.classList.toggle('has-qr', Boolean(ok));
        if (!ok) return;
        try { box.innerHTML = qrSvg(qrUrl()); }
        catch (e) { stage.classList.remove('has-qr'); }
    }

    /* ---------- Detalle del regalo (sin carrito: lo entrega un asesor) ---------- */
    var dImg = document.getElementById('dImg');

    function openDetail(i) {
        detailIdx = (i + shown.length) % shown.length;
        var p = shown[detailIdx];
        document.getElementById('dPos').textContent = (detailIdx + 1) + ' de ' + shown.length;
        document.getElementById('dVendor').textContent = p.v;
        document.getElementById('dTitle').textContent = p.t;
        document.getElementById('dDesc').textContent = p.d;
        setPhoto(p, 0);

        var thumbs = document.getElementById('dThumbs');
        thumbs.innerHTML = '';
        if (p.imgs.length > 1) p.imgs.forEach(function (src, k) {
            var b = document.createElement('button');
            b.type = 'button';
            b.setAttribute('aria-label', 'Foto ' + (k + 1));
            b.innerHTML = '<img src="' + imgUrl(src, 120) + '\" alt="" />';
            b.addEventListener('click', function () { setPhoto(p, k); });
            thumbs.appendChild(b);
        });
        markThumb(0);

        /* Modelos: solo se muestran cuando hay más de uno */
        var box = document.getElementById('dVariants');
        var chips = document.getElementById('dChips');
        chips.innerHTML = '';
        detailVar = firstVariant(p);
        box.hidden = p.vars.length < 2;
        p.vars.forEach(function (v) {
            if (p.vars.length < 2) return;
            var c = document.createElement('button');
            c.type = 'button';
            c.textContent = v[1];
            c.disabled = !v[2];
            if (!v[2]) c.title = 'Agotado';
            c.addEventListener('click', function () { detailVar = v; paintVariant(); });
            c._v = v;
            chips.appendChild(c);
        });
        paintVariant();

        if (current !== 'detail') show('detail');
        track('view_item', { ids: [detailVar[0]], name: p.t, value: detailVar[3], currency: 'MXN' });
    }

    function setPhoto(p, k) {
        dImg.src = imgUrl(p.imgs[k], 700);
        dImg.alt = p.t;
        markThumb(k);
    }

    function markThumb(k) {
        Array.prototype.forEach.call(document.getElementById('dThumbs').children, function (b, j) {
            b.classList.toggle('is-on', j === k);
        });
    }

    function paintVariant() {
        Array.prototype.forEach.call(document.getElementById('dChips').children, function (c) {
            c.classList.toggle('is-on', c._v === detailVar);
        });
        document.getElementById('dPrice').innerHTML = money(detailVar[3]);
    }

    function backToResults() { renderResults(); show('results', true); }
    document.getElementById('prevBtn').addEventListener('click', function () { openDetail(detailIdx - 1); });
    document.getElementById('nextBtn').addEventListener('click', function () { openDetail(detailIdx + 1); });
    document.getElementById('toResultsBtn').addEventListener('click', backToResults);
    document.getElementById('keepBtn').addEventListener('click', backToResults);

    document.getElementById('moreBtn').addEventListener('click', function () {
        resultsOffset = (resultsOffset + 3) % pool.length;
        renderResults();
        track('more_results', {});
    });

    document.getElementById('editBtn').addEventListener('click', function () { show(0, true); });

    /* ---------- Correo y celular, opcional al final ---------- */
    var gateOverlay = document.getElementById('gateOverlay');
    var gateCard = document.getElementById('gateCard');
    var gateForm = document.getElementById('gateForm');
    var gateEmail = document.getElementById('gateEmail');
    var gatePhone = document.getElementById('gatePhone');
    var gateError = document.getElementById('gateError');
    var gateBtn = document.getElementById('gateBtn');
    var gateSent = document.getElementById('gateSent');
    var leadDone = false;
    var gateDoneTimer = null;

    function paintOffer() {
        document.getElementById('offerRow').hidden = leadDone || !shown.length;
        gateSent.hidden = !leadDone;
    }

    function openGate() {
        gateCard.classList.remove('is-done');
        gateOverlay.hidden = false;
        requestAnimationFrame(function () { gateOverlay.classList.add('is-open'); });
        setTimeout(function () { gateEmail.focus({ preventScroll: true }); }, 350);
        track('email_offer_view', {});
    }

    function closeGate() {
        clearTimeout(gateDoneTimer);
        if (gateOverlay.hidden) return;
        if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
        gateOverlay.classList.remove('is-open');
        setTimeout(function () { gateOverlay.hidden = true; }, reduceMotion ? 0 : 300);
    }

    function clearForm() {
        gateForm.reset();
        gateEmail.classList.remove('is-bad');
        gatePhone.classList.remove('is-bad');
        gateError.textContent = '';
        gateBtn.disabled = false;
    }

    document.getElementById('offerBtn').addEventListener('click', openGate);
    document.getElementById('gateClose').addEventListener('click', closeGate);
    document.getElementById('gateSkip').addEventListener('click', function () { closeGate(); track('email_offer_skip', {}); });
    gateOverlay.addEventListener('click', function (e) { if (e.target === gateOverlay) closeGate(); });
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !gateOverlay.hidden) closeGate();
    });

    [gateEmail, gatePhone].forEach(function (input) {
        input.addEventListener('input', function () {
            input.classList.remove('is-bad');
            gateError.textContent = '';
        });
    });

    gatePhone.addEventListener('input', function () {
        gatePhone.value = gatePhone.value.replace(/[^\d ]/g, '');
    });

    function validEmail(v) {
        return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(v);
    }

    gateForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = gateEmail.value.trim();
        var phone = gatePhone.value.replace(/\D/g, '');
        if (!validEmail(email)) {
            gateEmail.classList.add('is-bad');
            gateError.textContent = 'Revisa tu correo, parece que le falta algo.';
            gateEmail.focus();
            return;
        }
        if (phone && phone.length !== 10) {
            gatePhone.classList.add('is-bad');
            gateError.textContent = 'El celular debe tener 10 dígitos.';
            gatePhone.focus();
            return;
        }
        gateBtn.disabled = true;
        subscribe(email, phone).then(function () {
            leadDone = true;
            /* El correo se muestra enmascarado: el siguiente cliente podría verlo */
            var masked = email.replace(/^(.)[^@]*(@.*)$/, '$1•••$2');
            gateSent.textContent = 'Listo. Te mandamos la lista y tu código de 10% a ' + masked + '.';
            document.getElementById('gateDoneMsg').textContent = 'Te mandamos la lista y tu código de 10% a ' + masked + '.';
            if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
            clearForm();
            gateCard.classList.add('is-done');
            paintOffer();
            gateDoneTimer = setTimeout(closeGate, 3500);
            track('lead', { con_celular: Boolean(phone) });
        }).catch(function () {
            gateBtn.disabled = false;
            gateError.textContent = 'No pudimos registrarte. Intenta de nuevo en un momento.';
        });
    });

    /* Alta en Klaviyo con las respuestas y los regalos como propiedades del perfil.
       El celular se guarda como dato (gm_celular); para mandar SMS hay que activar
       ese canal en Klaviyo con su consentimiento aparte. */
    function subscribe(email, phone) {
        var props = {
            gm_origen: 'totem',
            gm_edad: state.age, gm_para: state.gender, gm_presupuesto: state.budget, gm_ocasion: state.occasion
        };
        if (phone) props.gm_celular = '+52' + phone;
        shown.forEach(function (p, i) {
            var n = i + 1;
            props['gm_regalo_' + n + '_titulo'] = p.t;
            props['gm_regalo_' + n + '_precio'] = p.p;
            props['gm_regalo_' + n + '_url'] = STORE + '/products/' + p.h;
            props['gm_regalo_' + n + '_imagen'] = imgUrl(p.imgs[0], 600);
        });
        if (KLAVIYO.list === 'PENDIENTE') return new Promise(function (r) { setTimeout(r, 600); });
        return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO.company, {
            method: 'POST',
            headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
            body: JSON.stringify({
                data: {
                    type: 'subscription',
                    attributes: {
                        custom_source: 'Máquina de regalos (tótem)',
                        profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
                    },
                    relationships: { list: { data: { type: 'list', id: KLAVIYO.list } } }
                }
            })
        }).then(function (r) {
            if (!r.ok) throw new Error(r.status);
        });
    }

    /* ---------- Reiniciar: borra todo lo del cliente anterior ---------- */
    function resetAll() {
        clearInterval(searchTimer);
        searchRun++;
        state = {};
        labels = {};
        pool = [];
        shown = [];
        resultsOffset = 0;
        leadDone = false;
        clearForm();
        closeGate();
        gateOverlay.classList.remove('is-open');
        gateOverlay.hidden = true;
        document.getElementById('results').innerHTML = '';
        document.getElementById('qrBox').innerHTML = '';
        stage.classList.remove('has-qr', 'is-done', 'is-searching');
        document.querySelectorAll('.opt.is-selected').forEach(function (o) { o.classList.remove('is-selected'); });
        renderTickets();
        show(0, true);
        if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    }

    document.getElementById('kioskRestart').addEventListener('click', function () {
        track('restart', { step: String(current) });
        resetAll();
        armIdle();
    });

    /* ---------- Pantalla de espera ---------- */
    var attract = document.getElementById('attract');
    var attractTickets = document.getElementById('attractTickets');
    var attractOn = true;
    var demoTimer = null;
    var DEMO = [['circle', '3 a 6 años'], ['square', 'Para ella'], ['triangle', '$500 a $900'], ['rect', 'Cumpleaños']];

    /* La máquina de la pantalla de espera se llena sola con un ejemplo y suelta el regalo */
    function demoLoop(step) {
        clearTimeout(demoTimer);
        if (!attractOn) return;
        if (step === 0) {
            attractTickets.innerHTML = '';
            attract.classList.remove('is-done');
        }
        if (step < DEMO.length) {
            var t = document.createElement('span');
            t.className = 'ticket';
            t.innerHTML = '<i class="shape shape-' + DEMO[step][0] + '"></i>' + DEMO[step][1];
            attractTickets.appendChild(t);
            demoTimer = setTimeout(function () { demoLoop(step + 1); }, 1100);
        } else if (step === DEMO.length) {
            void attract.offsetWidth;
            attract.classList.add('is-done');
            demoTimer = setTimeout(function () { demoLoop(step + 1); }, 3600);
        } else {
            demoLoop(0);
        }
    }

    function showAttract() {
        attractOn = true;
        attract.classList.remove('is-hidden');
        attract.setAttribute('aria-hidden', 'false');
        if (!reduceMotion) demoLoop(0);
    }

    function hideAttract() {
        if (!attractOn) return;
        attractOn = false;
        clearTimeout(demoTimer);
        attract.classList.add('is-hidden');
        attract.setAttribute('aria-hidden', 'true');
        goFullscreen();
        keepAwake();
        drawCables();
        armIdle();
        getCatalog();
        track('wake', {});
    }

    attract.addEventListener('click', hideAttract);
    attract.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); hideAttract(); }
    });

    /* Pantalla completa y pantalla siempre encendida (si el navegador lo permite;
       en la tableta lo garantiza la app de kiosko) */
    function goFullscreen() {
        var el = document.documentElement;
        try {
            if (!document.fullscreenElement && el.requestFullscreen) el.requestFullscreen({ navigationUI: 'hide' }).catch(function () {});
        } catch (e) {}
    }

    var wakeLock = null;
    function keepAwake() {
        try {
            if (!wakeLock && navigator.wakeLock) navigator.wakeLock.request('screen').then(function (l) {
                wakeLock = l;
                l.addEventListener('release', function () { wakeLock = null; });
            }).catch(function () {});
        } catch (e) {}
    }

    document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') keepAwake();
    });

    /* ---------- Inactividad: 2 minutos y luego "¿Sigues ahí?" ---------- */
    var idle = document.getElementById('idle');
    var idleCount = document.getElementById('idleCount');
    var idleMeter = document.getElementById('idleMeter');
    var idleTimer = null;
    var countTimer = null;
    var idleOpen = false;

    function armIdle() {
        clearTimeout(idleTimer);
        if (attractOn || idleOpen) return;
        idleTimer = setTimeout(onIdle, IDLE_MS);
    }

    function onIdle() {
        /* Si nadie empezó, no hay nada que preguntar: vuelve a la pantalla de espera */
        if (!answered() && current === 0) { goToAttract(); return; }
        openIdle();
    }

    function openIdle() {
        idleOpen = true;
        var left = IDLE_COUNT;
        idleCount.textContent = left;
        idle.hidden = false;
        requestAnimationFrame(function () { idle.classList.add('is-open'); });
        idleMeter.getAnimations && idleMeter.getAnimations().forEach(function (a) { a.cancel(); });
        if (idleMeter.animate) idleMeter.animate([{ transform: 'scaleX(1)' }, { transform: 'scaleX(0)' }], { duration: IDLE_COUNT * 1000, easing: 'linear', fill: 'forwards' });
        clearInterval(countTimer);
        countTimer = setInterval(function () {
            left--;
            idleCount.textContent = Math.max(left, 0);
            if (left <= 0) goToAttract();
        }, 1000);
    }

    function closeIdle() {
        clearInterval(countTimer);
        idleOpen = false;
        idle.classList.remove('is-open');
        idle.hidden = true;
    }

    function goToAttract() {
        closeIdle();
        clearTimeout(idleTimer);
        if (answered()) track('timeout', { step: String(current) });
        resetAll();
        if (Date.now() - BOOTED_AT > RELOAD_AFTER) { location.reload(); return; }
        showAttract();
    }

    document.getElementById('idleStay').addEventListener('click', function () { closeIdle(); armIdle(); });
    document.getElementById('idleReset').addEventListener('click', goToAttract);

    ['pointerdown', 'keydown', 'input', 'touchstart'].forEach(function (ev) {
        document.addEventListener(ev, function () { if (!idleOpen) armIdle(); }, { passive: true });
    });

    /* ---------- Candados: que nadie se salga de la máquina ---------- */
    function notInput(e) {
        return !(e.target && e.target.closest && e.target.closest('input'));
    }

    ['contextmenu', 'dragstart', 'gesturestart', 'gesturechange'].forEach(function (ev) {
        document.addEventListener(ev, function (e) { e.preventDefault(); }, { passive: false });
    });

    document.addEventListener('selectstart', function (e) { if (notInput(e)) e.preventDefault(); });

    /* Sin zoom con dos dedos ni con Ctrl + rueda */
    document.addEventListener('touchmove', function (e) { if (e.touches.length > 1) e.preventDefault(); }, { passive: false });
    document.addEventListener('wheel', function (e) { if (e.ctrlKey) e.preventDefault(); }, { passive: false });

    /* Sin atajos del navegador (imprimir, guardar, abrir, zoom, recargar) */
    document.addEventListener('keydown', function (e) {
        var k = (e.key || '').toLowerCase();
        if ((e.ctrlKey || e.metaKey) && ['p', 's', 'o', 'u', 'l', 't', 'n', 'w', 'r', '+', '-', '=', '0'].indexOf(k) !== -1) e.preventDefault();
        if (k === 'f5' || k === 'f11' || k === 'f12') e.preventDefault();
    });

    /* El botón Atrás de Android se queda en la máquina */
    try {
        history.pushState({ totem: 1 }, '', location.href);
        window.addEventListener('popstate', function () {
            history.pushState({ totem: 1 }, '', location.href);
            if (!attractOn && !idleOpen && current !== 0) backBtn.click();
        });
    } catch (e) {}

    /* Por si un enlace se cuela (por ejemplo, desde el tema de Shopify), no se abre */
    document.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('a[href]');
        if (a) e.preventDefault();
    }, true);

    /* Si el QR cargó después de llegar a resultados, se pinta */
    window.addEventListener('load', function () { if (shown.length) paintQr(); });

    updateStepper();
    showAttract();
})();
